module.exports = __webpack_public_path__ + "static/media/promotion_en.d4b7c9a5.png";